/**
 * Benchmark page — workflow suites runner.
 *
 * @module pages/BenchmarkPage
 * @see docs/api/services/benchmark.md
 */
import { Link } from '@tanstack/react-router';
import { Box, Flex, Heading, Text } from '@chatsdet/ui';
import { Gear, CalendarCheck, CalendarPlus } from '@phosphor-icons/react';
import { WorkflowSuitePanel } from '../workflow-suites/WorkflowSuitePanel';
import { useWorkflowSuiteSchedule } from '../workflow-suites/useWorkflowSuiteSchedule';
import { ImportWorkflowDialog } from './ImportWorkflowDialog';
import { RunSuiteDialog } from './RunSuiteDialog';
import { RunAdHocBenchmarkDialog } from './RunAdHocBenchmarkDialog';

export function BenchmarkPage() {
  const scheduleQuery = useWorkflowSuiteSchedule();

  return (
    <Box className="space-y-6">
      {/* Header */}
      <Flex justify="between" align="center" wrap gap="md">
        <div>
          <Heading level={2}>Benchmark</Heading>
          <Text className="text-muted-foreground mt-1">
            Track AI model performance and workflow execution reliability
          </Text>
        </div>
        <Flex gap="md" align="center">
          <Link
            to="/superadmin/benchmark/configs"
            className="flex items-center justify-center w-9 h-9 rounded-md border border-border text-muted-foreground no-underline hover:text-foreground hover:border-primary/50 transition-colors"
            title="Benchmark Configurations"
          >
            <Gear size={18} />
          </Link>
          <ImportWorkflowDialog />
          {scheduleQuery.data?.schedule ? (
            <Link
              to="/superadmin/scheduled"
              className="flex items-center gap-1.5 text-sm text-success no-underline hover:underline"
            >
              <CalendarCheck size={16} />
              Scheduled
              {scheduleQuery.data.schedule.enabled === false && (
                <Text as="span" size="xs" className="text-muted-foreground">(paused)</Text>
              )}
            </Link>
          ) : (
            <Link
              to="/superadmin/scheduled"
              className="flex items-center gap-1.5 text-sm text-muted-foreground no-underline hover:text-foreground hover:underline"
            >
              <CalendarPlus size={16} />
              Add schedule
            </Link>
          )}
          <RunAdHocBenchmarkDialog />
          <RunSuiteDialog />
        </Flex>
      </Flex>

      <WorkflowSuitePanel />
    </Box>
  );
}
